





























import Vue from "vue";
import OrdersFilters from "./OrdersFilters.vue";
import { FilterOrderValues } from "./OrdersFilters.vue";
import Widget from "../../components/Widget.vue";
import { ApplicationActions } from "../../store";
import { Dispatcher, Committer } from "vuex-type-helper";
import {
  AutobedrijfViewModel,
  DropdownItemStringViewModel,
  FixedPeriodType,
} from "../../TypeScriptModels";
import axios, { AxiosPromise } from "axios";
import get from "lodash-es/get";
import debounce from "lodash-es/debounce";
import isNumber from "lodash-es/isNumber";
import isEmpty from "lodash-es/isEmpty";
import moment from "moment";

interface DashboardOrdersQueryWidgetViewModel {
  FromDate: string;
  ToDate: string;
  Zones: number[];
  Autobedrijven: string[];
  Vestigingen: string[];
  Modellen: string[];
  Merken: string[];
}

export default Vue.extend({
  components: {
    OrdersFilters,
    Widget,
  },

  data() {
    return {
      pageInitialised: false,
      selectedOptions: {
        period: null as null | any,
        zonesValue: [] as any[],
        autobedrijvenValue: [] as any[],
        vestigingenValue: [] as any[],
        modellenValue: [] as any[],
        merkenValue: [] as any[],
        periodFromDate: new Date(),
        periodToDate: new Date(),
        customFromDate: new Date(),
        customToDate: new Date(),
      } as FilterOrderValues,
      getDataDebounced: null as null | Function,
      widgetValue: -1,
      destroyed: false,
      waitConnect: 2500,
      timerRenewToken: 0,
      websocket: null as null | WebSocket,
    };
  },

  created() {
    this.selectedOptions.period = {
      Id: FixedPeriodType.ThisYear,
      Omschrijving: `${this.$i18n.t("timefilters.thisyear")}`,
    };

    this.getDataDebounced = debounce(() => {
      this.getOrdersData();
    }, 500);
  },
  mounted() {
    this.connect();
    this.destroyed = false;
  },

  computed: {
    multipleMakes(): boolean {
      return this.$store.getters.multipleMakes();
    },
  },

  methods: {
    renewToken() {
      this.$store.dispatch<Dispatcher<ApplicationActions>>({
        type: "renewTokenIfOutdated",
      });
    },

    connect() {
      if (!this.destroyed && "WebSocket" in window) {
        let that = this;
        let protocol = location.protocol === "https:" ? "wss://" : "ws://";

        this.websocket = new WebSocket(
          protocol + location.host + "/api/backend/v1/dashboard/orders/live"
        );

        this.websocket.onopen = () => {
          this.waitConnect = 2500;
          //console.log("websocked opened!");
          if (!this.timerRenewToken) {
            this.timerRenewToken = setInterval(this.renewToken, 30 * 60 * 1000);
          }
        };

        this.websocket.onmessage = (evt) => {
          const received_msg = evt.data;
          console.log(Math.floor(Date.now()) + "  " + received_msg);

          try {
            let obj = JSON.parse(evt.data);

            this.handleDataChanged();
          } catch (err) {}
        };

        this.websocket.onclose = () => {
          // console.log("websocked closed");
          if (!this.destroyed) {
            // Reconnect will be attempted after a while
            setTimeout(() => {
              if (this.waitConnect > 1000 * 6) {
                this.$router.push({ name: "logout" });
              } else {
                that.connect();
                this.waitConnect += 500;
              }
            }, this.waitConnect);
          }
        };
      }
    },

    onFiltersInitialised() {
      this.pageInitialised = true;
      this.onFilterPreferencesChanged();
    },

    onFilterPreferencesChanged() {
      this.handleDataChanged();
    },

    handleDataChanged() {
      if (!!this.getDataDebounced) this.getDataDebounced();
    },

    getOrdersData() {
      this.queryData()
        .then((response) => {
          if (!!response && !!response.data && isNumber(response.data.Orders)) {
            this.widgetValue = response.data.Orders;
          }
        })
        .catch((error) => {});
    },

    queryData(): AxiosPromise {
      const isCustomInput =
        get(this.selectedOptions, "period.Id", FixedPeriodType.ThisYear) ===
        FixedPeriodType.FreePeriod;

      let model = {
        FromDate: isCustomInput
          ? (moment(this.selectedOptions.customFromDate)).local().startOf("day").toDate().toISOString()
          : this.selectedOptions.periodFromDate.toISOString(),
        ToDate: isCustomInput
          ? (moment(this.selectedOptions.customToDate)).local().endOf("day").toDate().toISOString()
          : this.selectedOptions.periodToDate.toISOString(),		        
        Zones: get(this.selectedOptions as Object, "zonesValue", []).map(
          (elem: any) => Number(elem["Id"])
        ),
        Autobedrijven: get(
          this.selectedOptions as Object,
          "autobedrijvenValue",
          []
        ).map((elem: any) => String(elem["Id"])),
        Vestigingen: get(
          this.selectedOptions as Object,
          "vestigingenValue",
          []
        ).map((elem: any) => Number(elem["Id"])),
        Modellen: get(this.selectedOptions as Object, "modellenValue", []).map(
          (elem: any) => String(elem["Id"])
        ),
        Merken: [],
      } as DashboardOrdersQueryWidgetViewModel;

      if (this.multipleMakes) {
        model.Merken = get(
          this.selectedOptions as Object,
          "merkenValue",
          []
        ).map((elem: any) => String(elem["Id"]));
      }

      return axios.post("/api/backend/v1/dashboard/orders/query", model, {
        headers: { "Content-Type": "application/json" },
      });
    },
    beforeDestroy() {
      this.destroyed = true;
      if (!!this.websocket) {
        this.websocket.close();
      }
      if (!!this.timerRenewToken) {
        clearInterval(this.timerRenewToken);
      }
    },
  },
});
